import { z } from 'zod';
export const DataSourceKindSchema = z.enum([
    'personio',
    'excel'
]);

//# sourceMappingURL=data-source-kind.schema.js.map